import axios from "axios";
import { getBaseUrl } from "../../utils/common";

// import getBaseUrl from "./analytics-url";

export default axios.create({
    baseURL: `${getBaseUrl()}/analytics/V1`,
    //withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});
